import React, {memo, useEffect, useState} from 'react';

import Header2 from '../../../../../../components/headers/header2';
import {Column, Row} from '../../../../../../components/layout';
import AppDrapDropFileInput from '../../../../../../components/app-drap-drop-file-input';
import './styles.scss';
import AppButton from '../../../../../../components/app-button';
import {connect} from 'react-redux';
import {compose} from 'redux';
import {addToWizard} from '../../../../../../store/actions';
import {get} from '../../../../../../api/api';
import {uriGetDocumentTypes} from '../../../../../../api/endpoints';
import {createGUID} from '../../../../../../util/utility';
import PopupList from '../../../../../../components/popup-list';
import * as fonts from '../../../../../../util/fonts';
import colors from '../../../../../../util/colors';
import {NewInvoiceValidationProps} from '../NewInvoiceValidation';
import {useLocation} from 'react-router-dom';
import NewErrorMessage from '../../../../../../components/new-error-message';
import {Icons} from '../../../../../../util/icons';

const NewAttachFiles = memo(
  ({
    preAuth,
    addToWizard,
    labels,
    labelsPreAuthorizations,
    showPopup,
    titleOfButton,
    nextStep,
    setOldFiles,
    labelFiles,
  }: NewInvoiceValidationProps) => {
    const [files, setFiles] = useState<any[]>([]);
    const [submitting, setSubmitting] = useState(false);
    const [show, setShow] = useState(false);
    const [filesAdded, setFilesAdded] = useState<any[]>();
    const [typeOfDocument, setTypeOfDocument] = useState<any[]>([]);
    const location = useLocation();
    const [submitCount, setSubmitCount] = useState<number>(0);
    const [showError, setShowError] = useState<boolean>(false);

    const featureName = 'Reimbursements-AttachFiles';

    const onFileAdd = (addedFiles: any[]) => {
      setShow(showPopup);
      setFilesAdded(addedFiles);
    };

    async function getTypesOfDocumentsOptions() {
      const response: any = await get(
        uriGetDocumentTypes(),
        false,
        0,
        featureName,
      );
      const typeOfDocuments = response.data.documentTypes;

      let newProceed: any[] = [];

      setTypeOfDocument(
        (typeOfDocuments as any).map((item: any) => {
          newProceed.push({...item});

          return {
            value: item.code,
            label: item.description,
          };
        }),
      );
    }

    useEffect(() => {
      if (location.pathname.includes('pre-aut')) {
        getTypesOfDocumentsOptions();
      }
    }, [location.pathname]);

    // Clear error when files are added
    useEffect(() => {
      if (files.length > 0 && showError) {
        setShowError(false);
      }
    }, [files.length, showError]);

    const handleConfirmOnClick = async () => {
      setSubmitCount(submitCount + 1);
      if (files.length === 0) {
        setShowError(true);
        return;
      }
      setShowError(false);
      const sessionId = createGUID();
      try {
        setSubmitting(true);
        setOldFiles(files);
        addToWizard({
          attachFiles: {
            sessionId: sessionId,
          },
        });
      } catch (e: any) {
      } finally {
        setSubmitting(false);
      }
      nextStep();
    };

    const onSubmitPopupList = (value: any) => {
      let newFiles = [...files];
      newFiles.forEach((item) => {
        let idAddedFile = filesAdded?.find((id) => item.id === id);
        if (idAddedFile) {
          item.name = value;
        }
        setShow(false);
      });
      setFiles(newFiles);
    };

    const onClosePopupList = () => {
      let newFiles = [...files];
      newFiles.forEach((item, index) => {
        let idAddedFile = filesAdded?.find((id) => item.id === id);
        if (idAddedFile) {
          delete newFiles[index];
        }
      });
      setFiles(newFiles.filter((item) => item !== undefined));
    };

    return (
      <Column className="attach-files-container">
        <Header2
          className="attach-files-title"
          style={{...fonts.ML, ...fonts.Bold, color: colors.black}}>
          {files.length > 0
            ? preAuth
              ? labelsPreAuthorizations?.preAuthorizations_attachOtherDocuments
              : labels?.createRefund_moreDocumentstext
            : labelFiles}
        </Header2>
        {showError && (
          <NewErrorMessage
            text={labels?.createRefund_invalidInput}
            iconName={Icons.ALERT_PROBLEM}
            colorIcon={colors.alertRed}
          />
        )}
        <Row>
          <AppDrapDropFileInput
            preAuth={preAuth}
            files={files}
            setFiles={setFiles}
            newFilesName={labels?.createRefund_invoice}
            onFileAdd={onFileAdd}
            customOnDropBehavior={() => {
              setShowError(false);
            }}
            submitCount={submitCount}
          />
        </Row>
        <Row className="attach-files-confirm-button-row">
          <AppButton
            className="attach-files-confirm-button"
            disabled={submitting}
            onClick={handleConfirmOnClick}>
            {titleOfButton}
          </AppButton>
        </Row>
        <PopupList
          onSubmit={(value) => onSubmitPopupList(value)}
          onClose={() => onClosePopupList()}
          title={labelsPreAuthorizations?.preAuthorizations_documentType}
          show={show}
          list={typeOfDocument}
          setShowModal={setShow}
          titleOfButton={labels?.createRefund_confirm}></PopupList>
      </Column>
    );
  },
);

const mapStateToProps = ({user, wizard, strings}: any) => ({
  user: user.value,
  wizard: wizard.value,
  labels: strings.value.pt.createRefund,
  labelsPreAuthorizations: strings.value.pt.preAuthorizations,
});

const mapDispatchToProps = (dispatch: any) => ({
  addToWizard: (value: any) => dispatch(addToWizard(value)),
});

export default compose(
  connect(mapStateToProps, mapDispatchToProps)(NewAttachFiles),
);
